export const getRandomInRange = (min: number, max: number) => {
  return Math.random() * (max - min) + min;
};

export const getRandomRgb = () => {
  const r = getRandomInRange;
  return [r(0, 150), r(0, 150), r(0, 150)];
  // return `${r(0, 150)},${r(0, 150)},${r(0, 150)}`;
};
